import type { DeepPartial } from '@luna/utils-ts';

import type { Charts } from '../../types/Charts';

export const chartsCZFeatureConfig: DeepPartial<Charts> = {
    numberOfPerformanceChartBars: 4,
    decorateLastYearWithAsterisk: true,
};
